import { TerminalToCampaignEntityToDto } from "src/app/features/Campaign/services/mappers/TerminalToCampaignEntityToDto";
import type { CampaignDto } from "src/app/features/Campaign/types/CampaignDto";
import type { CampaignEntity } from "src/app/features/Campaign/types/CampaignEntity";

export const CampaignEntityToDto = (campaign: Readonly<CampaignEntity>): CampaignDto => {
    let sites2;
    let updateDateFrom2;
    let updateDateTo2;
    let updateTimeFrom2;
    let updateTimeTo2;
    let requiredDiskSizeMB2;
    let adjustUpdateSchedule2;
    let postponeUpdateDate2;
    let postponeUpdateHoursFrom2;
    let postponeUpdateHoursTo2;
    let terminalToCampaign2;
    let terminalToCampaignIds2;
    let terminals2;

    // if all terminals are selected send an empty list
    const terminalsList1 = campaign.terminals1?.areAllTerminalsSelected ? [] : campaign.terminals1?.terminalIdList;
    const terminalsList2 = campaign.terminals2?.areAllTerminalsSelected ? [] : campaign.terminals2?.terminalIdList;

    if (campaign.phase2Enabled) {
        sites2 = campaign.sites2;
        updateDateFrom2 = campaign.updateDateFrom2;
        updateDateTo2 = campaign.updateDateTo2;
        updateTimeFrom2 = campaign.updateTimeFrom2;
        updateTimeTo2 = campaign.updateTimeTo2;
        requiredDiskSizeMB2 = campaign.requiredDiskSizeMB2;
        adjustUpdateSchedule2 = campaign.adjustUpdateSchedule2;
        postponeUpdateDate2 = campaign.postponeUpdateDate2;
        postponeUpdateHoursFrom2 = campaign.postponeUpdateHoursFrom2;
        postponeUpdateHoursTo2 = campaign.postponeUpdateHoursTo2;
        terminalToCampaign2 = campaign.terminalToCampaign2?.map((terminalToCampaign) => TerminalToCampaignEntityToDto(terminalToCampaign));
        terminalToCampaignIds2 = campaign.terminalToCampaign2?.map((terminal) => Number(terminal.id)) || [];
        terminals2 = terminalsList2;
    }

    // This boolean logic makes both true when campaign.updateType is "BOTH"
    const updateEftVersion = campaign.updateType !== "CONFIGURATION";
    const updateConfiguration = campaign.updateType !== "EFT_VERSION";

    return {
        id: campaign.id,
        name: campaign.name,
        type: campaign.type,
        updateType: campaign.updateType,
        updateEftVersion,
        updateConfiguration,
        phase2Enabled: campaign.phase2Enabled,
        campaignPhasesCount: campaign.campaignPhasesCount,
        validTo: campaign.validTo,
        validFrom: campaign.validFrom,
        state: campaign.state,
        owner: campaign.owner,
        changed: campaign.changed,
        sites1: campaign.sites1,
        updateDateFrom1: campaign.updateDateFrom1,
        updateDateTo1: campaign.updateDateTo1,
        updateTimeFrom1: campaign.updateTimeFrom1,
        updateTimeTo1: campaign.updateTimeTo1,
        requiredDiskSizeMB1: campaign.requiredDiskSizeMB1,
        adjustUpdateSchedule1: campaign.adjustUpdateSchedule1,
        postponeUpdateDate1: campaign.postponeUpdateDate1,
        postponeUpdateHoursFrom1: campaign.postponeUpdateHoursFrom1,
        postponeUpdateHoursTo1: campaign.postponeUpdateHoursTo1,
        periodDay1: campaign.periodDay1,
        terminalToCampaign1: campaign.terminalToCampaign1?.map((terminalToCampaign) => TerminalToCampaignEntityToDto(terminalToCampaign)),
        terminalToCampaignIds1: campaign.terminalToCampaign1?.map((terminal) => Number(terminal.id)) || [], // this is TerminalToCampaignId it should be terminal id. It is 148 not 7.
        sites2,
        updateDateFrom2,
        updateDateTo2,
        updateTimeFrom2,
        updateTimeTo2,
        requiredDiskSizeMB2,
        adjustUpdateSchedule2,
        postponeUpdateDate2,
        postponeUpdateHoursFrom2,
        postponeUpdateHoursTo2,
        terminalToCampaign2,
        terminalToCampaignIds2,
        terminals2,
        terminals1: terminalsList1,
    };
};
